import React, {createContext, useReducer} from "react";
import Reducer from './reducer'

const monthAgo = (from) => {
    var d = new Date(from);
    d.setDate(0); // set to last day of previous month
    d.setDate(1); // set to the first day of that month
    return d;
}

const getAnonymous = () => {
    return {
        isAuthenticated: false,
        name:"Agent Smith",
        email:"",
        picture:"http://s3.amazonaws.com/Survey_Pics/surveys/pic1s/000/000/125/original/agent-smith-vs-elf-matrix-lord-of-the-rings-funpoll-fun.png"
    }
}

const initialState = {
    meta: {
        date_from:          {type: 'date'},
        date_to:            {type: 'date'},
        date_aggregation:   {type: 'select-multiple'}
    },
    filters: {
        date_from:          monthAgo(new Date()).toISOString().slice(0,10),
        date_to:            new Date().toISOString().slice(0,10),
        date_aggregation:   'month'
    },
    anonymous: getAnonymous(),
    user: getAnonymous()
};

const Store = ({children}) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    return (
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
    )
};

export const Context = createContext(initialState);
export default Store;